module.exports = __webpack_public_path__ + "static/media/Concept_Buildings_04.7545791b.jpg";